import React from 'react';
import { Search, MapPin } from 'lucide-react';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-[#0B0B0B] text-white pt-24 pb-32 px-4 sm:px-6 lg:px-8" data-id="element-245">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/1UWX3upNAeRHGAGLj3nnFR/WhatsApp_Image_2026-03-20_at_13.12.53.jpg" alt="Los Santos" className="absolute inset-0 w-full h-full object-cover" data-id="element-246" />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/70" data-id="element-247" />
      {/* Subtle gold radial glow */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
      background: 'radial-gradient(circle at 50% 0%, rgba(201,163,78,0.25) 0%, transparent 60%)'
    }} data-id="element-248" />

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-249">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight mb-6 leading-tight text-white" data-id="element-250">
          El marketplace gastronómico de{' '}
          <span className="text-[#C9A34E]" data-id="element-251">Los Santos</span>
        </h1>
        <p className="text-lg sm:text-xl text-white/60 mb-10 max-w-2xl mx-auto font-medium" data-id="element-252">
          Descubre, ordena y disfruta de los mejores restaurantes de la zona en
          un solo lugar.
        </p>

        {/* Search Bar */}
        <div className="bg-[#141414] border border-white/10 p-2 rounded-2xl sm:rounded-full shadow-lg max-w-3xl mx-auto flex flex-col sm:flex-row items-center gap-2" data-id="element-253">
          <div className="flex-1 w-full flex items-center px-4 py-2 border-b sm:border-b-0 sm:border-r border-white/10" data-id="element-254">
            <MapPin className="w-5 h-5 text-white/40 mr-3 shrink-0" data-id="element-255" />
            <select className="w-full bg-transparent text-white focus:outline-none appearance-none cursor-pointer font-medium" data-id="element-256">
              <option value="" className="bg-[#141414]" data-id="element-257">
                Todas las zonas
              </option>
              <option value="san-marcos" className="bg-[#141414]" data-id="element-258">
                San Marcos
              </option>
              <option value="santa-maria" className="bg-[#141414]" data-id="element-259">
                Santa María
              </option>
              <option value="dota" className="bg-[#141414]" data-id="element-260">
                Dota
              </option>
            </select>
          </div>

          <div className="flex-1 w-full flex items-center px-4 py-2" data-id="element-261">
            <Search className="w-5 h-5 text-white/40 mr-3 shrink-0" data-id="element-262" />
            <input type="text" placeholder="¿Qué se te antoja hoy?" className="w-full bg-transparent text-white focus:outline-none placeholder:text-white/30" data-id="element-263" />
          </div>

          <button className="w-full sm:w-auto bg-[#C9A34E] text-[#0B0B0B] font-bold rounded-xl sm:rounded-full px-8 py-3 shrink-0 hover:bg-[#d4b365] transition-colors active:scale-95" data-id="element-264">
            Buscar
          </button>
        </div>
      </div>
    </div>;
}